import Vue from 'vue'
import Vuex from 'vuex'
import vuexAlong from 'vuex-along'
import invoice from './modules/invoice/invoice'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    invoice
  },
  plugins: [vuexAlong]
})



// WEBPACK FOOTER //
// ./src/store/index.js